<template>
  <div class="confirm-record-popup">
    <p>
      This will overwrite your previous recording. Is this what you want to do?
    </p>

    <p>
      If you click Yes, Your new recording will begin when this box closes.
    </p>

    <div>
      <button class="btn btn-primary yes-btn" @click="confirmRecord">
        Yes
      </button>

      <button class="btn-secondary" @click="closeModal">
        No
      </button>
    </div>
  </div>
</template>

<script>
import { record } from "../../mixins/Record";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfirmRecordPopupVue",
  mixins: [record],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      modal: "getModal"
    })
  },
  methods: {
    ...mapMutations({
      setModal: "setModal"
    }),

    /**
     * Function to close the modal
     */
    closeModal() {
      this.setModal({
        ...this.modal,
        display: false
      });
    },

    /**
     * Function to confirm recording
     */
    confirmRecord() {
      this.closeModal();
      this.startRecording();
    }
  }
};
</script>

<style scoped>
.yes-btn {
  margin-right: 1%;
}

.confirm-record-popup {
  font-size: 14px;
  color: #fff;
}
</style>
